import i18n from "../i18n";

/**
 * Returns the disclaimer.
 *
 * Return custom one if it is set.
 * Return by disclaimers.year if it is set.
 * Retrun default dislaimer.
 *
 * @param {Fund} fund
 * @returns {string}
 */
export const getDisclaimer = (fund) => {
  // if there is a custom disclaimer, return it
  if (fund.reportDisclaimer) return fund.reportDisclaimer;

  // i18n returns the key if the translation is not found
  // so if it is not the key, the translation exists
  const key = `fund.report.disclaimers.${fund.auditPeriod.year}`;
  const dedicated = i18n.t(key, fund.language);

  if (dedicated !== key) return dedicated;

  // return the default disclaimer
  return i18n.t("fund.report.disclaimer", fund.language, {
    year: fund.auditPeriod.year + 1,
  });
};
